import { all, call, fork, put, takeEvery, select } from 'redux-saga/effects';

// action creators
import { doneIndicator } from 'store/actions/httpActions';

// selector
import getCurrentGroupId from 'store/selectors/getCurrentGroupId';

// api
import client from 'sources/api';

// constants
import {
  PHONE_NUMBER_UPDATE_REQUEST,
  PHONE_NUMBER_UPDATE,
} from 'store/constants/phoneNumberTypes';

// schemas
import { phoneNumberSchema } from 'store/schemas/phoneNumberSchema';

// helpers
import httpSaga from 'store/sagas/httpSaga';

const WATCH_TYPE = PHONE_NUMBER_UPDATE_REQUEST;
const TYPE = PHONE_NUMBER_UPDATE;

export function* updatePhoneNumberSaga(action: any) {
  const {
    payload: {
      phoneNumberId,
      accountId: account_id,
      allowCallForwarding: allow_call_forwarding,
      twoWayMessagingEnabled: two_way_messaging_enabled,
    },
  } = action;

  const currentGroupId = yield select(getCurrentGroupId);

  // @ts-expect-error ts-migrate(2569) FIXME: Type 'Generator<any, any, unknown>' is not an arra... Remove this comment to see the full error message
  yield* httpSaga(
    TYPE,
    call(
      client.patch,
      `/phone_numbers/${phoneNumberId}?group_id=${currentGroupId}`,
      { account_id, allow_call_forwarding, two_way_messaging_enabled }
    ),
    {
      schema: phoneNumberSchema,
      metaId: `update-${phoneNumberId}`,
    }
  );
  yield put(doneIndicator(TYPE));
}

export function* watch() {
  yield takeEvery(WATCH_TYPE, updatePhoneNumberSaga);
}

export default function* root() {
  yield all([fork(watch)]);
}
